export default __webpack_public_path__ + "static/media/E6.ccdef29a.jpg";